import { ProtectedRouter } from 'infrastructure/routing';
import { Route, Routes } from 'react-router-dom';
import { PERFORMANCE_MEASUREMENT_GET } from 'domain/shared/performanceMeasurement';
import { createRoute } from 'framework/routing';
import { Page404 } from 'framework/statusPages';
import useAuthenticationService from 'infrastructure/security/authentication/authenticationService';
import EmployeeScoreContext from './EmployeeScoreContext';
import EmployeeScoreList from './downloadReport';

export const EMPLOYEE_SCORE_PATH = '/score';

const EmployeeScoreRouter = () => {
  const { isAuthenticated } = useAuthenticationService();
  const { listRoute } = createRoute({ listRoute: EMPLOYEE_SCORE_PATH });

  return (
    <ProtectedRouter basePath={EMPLOYEE_SCORE_PATH}>
      <Routes>
        <Route
          path={listRoute}
          element={
            <EmployeeScoreContext permissionToCheck={PERFORMANCE_MEASUREMENT_GET}>
              <EmployeeScoreList />
            </EmployeeScoreContext>
          }
        />
        <Route path="*" element={<Page404 isAuthenticated={isAuthenticated} />} />
      </Routes>
    </ProtectedRouter>
  );
};

EmployeeScoreRouter.getRouterPath = () => `${EMPLOYEE_SCORE_PATH}/*`;

export default EmployeeScoreRouter;
